<template>
    <div class="login-wrap" ref="login">
        <section class="login-container">
            <div class="login-container-header">
                <h3>乐纯管理平台登录</h3>
            </div>
            <div v-if="codexPlusError" class="codexplus-login-result codexplus-login-error">
                <i class="el-icon-warning-outline"></i>
                <strong>钉钉登录失败</strong>
                <span>{{ codexPlusError }}</span>
            </div>
            <div v-else-if="codexPlusCompleted" class="codexplus-login-result">
                <i class="el-icon-circle-check"></i>
                <strong>钉钉登录成功</strong>
                <span>可以关闭此页面并返回 CodexPlus</span>
            </div>
            <div v-else-if="this.isInDingTalk||this.code!=''" style="padding:10px 0;text-align: center;font-size: 14px;font-weight: bolder">
                <i style="font-size: 20px" class="el-icon-loading"></i> 登录中......请稍后
            </div>
            <div v-else class="login-container-body">
                <el-form ref="form"
                         :model="form"
                         status-icon
                         hide-required-asterisk
                         :rules="rules" label-width="60px">
                    <el-form-item label="账号" prop="userName">
                        <el-input ref="userNameInput" v-model="form.userName" placeholder="请输入账号" @blur="onUserNameBlur"></el-input>
                    </el-form-item>
                    <el-form-item label="密码" prop="passWord">
                        <el-input v-model="form.passWord" type="password" show-password placeholder="请输入密码"></el-input>
                    </el-form-item>
                    <el-form-item v-if="showValidateCode!='0'" label="验证码" prop="imageValidateCode">
                        <el-input class="img-input" v-model="form.imageValidateCode" placeholder="请输入图片验证码">
                            <img  slot="append" @click="getCaptcha" style="width: auto;height: 38px;display: block" :src="imgCode"/>
                        </el-input>
                    </el-form-item>
                    <el-form-item v-if="showAutoLoginOption" label-width="0" class="auto-login-item">
                        <div class="auto-login-row">
                            <el-checkbox v-model="form.autoLogin" class="auto-login-check">{{ autoLoginLabel }}</el-checkbox>
                        </div>
                    </el-form-item>
                </el-form>
                <div style="text-align: center">
                    <el-button type="primary" @click="onSubmit">账号登录</el-button>
                    <el-button type="primary" plain @click="dingLoginPage">钉钉登录</el-button>
                </div>

            </div>

        </section>
        <forgetPassword ref="forgetPasswordDialog" @closeDialog="closeDialog"></forgetPassword>
        <editPassword ref="editPasswordDialog" @closeEditDialog="closeEditDialog"></editPassword>
    </div>
</template>

<script>
import { resolveLoginReturn, appendLoginDisplayFields } from '@/utils/login-return'

    import crypto from 'crypto'
    import forgetPassword from "@c/forgetPassword";
    import editPassword from "@c/editPassword";
    import * as dd from 'dingtalk-jsapi';
    export default {
        data() {
            return {
                imgCode:'',
                showValidateCode:'',
                loginErrorCount: 0,
                corpId:'ding5473140ac462716435c2f4657eb6378f',
                clientId:'dingqtyl0pccf1xzawht',
                code:this.$route.query.code||'',
                codexPlusState:this.$route.query.codexPlusState||'',
                codexPlusCompleted:false,
                codexPlusError:'',
                returnPage: this.$route.query.returnPage,
                userId:'',
                userName:'',
                userNick:'',
                autoLoginDays:30,
                showAutoLoginOption: false,
                form: {
                    userName:'',
                    passWord:'',
                    imageValidateCode:null,
                    autoLogin:true
                },
                rules: {
                    userName: [
                        { required:true,message:'账号不能为空' }
                    ],
                    passWord: [
                        { required:true,message:'密码不能为空' }
                    ],
                    imageValidateCode: [
                        { required:true,message:'图片验证码不能为空', trigger: 'blur' }
                    ],
                },
                isInDingTalk:/DingTalk|DingTalkBrowser/.test(navigator.userAgent)
            }
        },
        components:{
            forgetPassword,editPassword
        },
        mounted(){
            if(this.isInDingTalk){
                dd.runtime.permission.requestAuthCode({
                    corpId: this.corpId,
                    clientId: this.clientId,
                    onSuccess: (result)=> {
                        this.DingLogin(result.code,'ding')
                    },
                    onFail: (err)=> {
                        this.$message({
                            showClose: false,
                            message: '登录失败，请重试',
                            type: 'error'
                        });
                    },
                });
            }else{
                // 回填上次登录账号，同时带 userName 查询是否需要验证码
                const savedUser = window.localStorage.getItem('loginUser') || ''
                if (savedUser) {
                    this.form.userName = savedUser
                }
                if (this.$route.query.autoLogin !== undefined) {
                    this.form.autoLogin = this.$route.query.autoLogin === '1'
                }
                this.getCaptcha()
                if(this.code!=''){
                    // 2026-08-08 coder(lq): CodexPlus 回调必须使用发起登录时的 OAuth state，阻止浏览器中的其他授权结果串入当前桌面登录。
                    if (this.codexPlusState && !this.isValidCodexPlusState(this.codexPlusState)) {
                        this.codexPlusError = '登录状态无效，请返回 CodexPlus 重新发起'
                    } else if (this.codexPlusState && this.$route.query.state !== this.codexPlusState) {
                        this.codexPlusError = '登录状态校验失败，请返回 CodexPlus 重新发起'
                    } else {
                        this.DingLogin(this.code)
                    }
                }
                this.$refs.login.onkeydown = (e)=> {
                    e = e || window.event;
                    if(e.keyCode == 13) {
                        this.onSubmit()
                    }
                }
            }

        },
        computed: {
            autoLoginLabel() {
                const days = Number(this.autoLoginDays) > 0 ? Number(this.autoLoginDays) : 30
                return `${days}天内免登录`
            }
        },
        methods: {
            isValidCodexPlusState(state) {
                return /^[0-9a-f]{64}$/.test(state || '')
            },
            onSubmit() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        this.$apiGet('lechun-baseservice/auth/login',{
                            userName:this.form.userName,
                            passWord:this.getmd5(this.form.passWord),
                            imageValidateCode:this.form.imageValidateCode||null,
                            autoLogin:this.form.autoLogin ? 1 : 0}).then(res=>{
                            this.$message({
                                message: `登录成功(${res.userName})`,
                                type: 'success'
                            });
                            window.localStorage.setItem('loginUser',this.form.userName);
                            window.localStorage.setItem('userId',res.userId);
                            this.userId = res.userId
                            this.userName = res.userName
                            this.userNick = res.userNick
                            if (res.simplePwd === 1) {
                                this.$refs.editPasswordDialog.openEditDialog(true)
                            } else {
                                this.returnPageFun()
                            }
                        }).catch(()=>{
                            // 登录失败后刷新验证码状态（判断是否需要显示验证码）
                            this.loginErrorCount++
                            this.form.imageValidateCode = null
                            this.getCaptcha()
                        })
                    } else {
                        return false;
                    }
                });
            },
            // 账号失焦：兼容浏览器自动填充场景（autofill 不触发 v-model 的 input 事件）
            onUserNameBlur(){
                const nativeValue = this.$refs.userNameInput.$el.querySelector('input').value
                if (nativeValue && !this.form.userName) {
                    this.form.userName = nativeValue
                }
                this.getCaptcha()
            },
            getCaptcha(){
                this.$apiGet('lechun-baseservice/auth/captcha',{userName: this.form.userName || ''}).then(res=>{
                    this.imgCode = res.image||''
                    const autoLoginDays = Number((res && res.autoLoginDays) || 0)
                    if (autoLoginDays > 0) {
                        this.autoLoginDays = autoLoginDays
                    }
                    // 登录失败过则强制显示验证码（验证码接口 showValidateCode 未正确反映失败状态）
                    if (this.loginErrorCount >= 3) {
                        this.showValidateCode = '1'
                    } else {
                        this.showValidateCode = res.showValidateCode
                    }
                })
            },
            getmd5(params){
                let md5 = crypto.createHash("md5");
                md5.update(params);
                return md5.digest('hex');
            },
            forgetPassword(){
                this.$refs.forgetPasswordDialog.openForgetDialog()
            },
            closeDialog(){
                this.getCaptcha()  // 忘记密码弹窗关闭后刷新验证码状态
            },
            returnPageFun(){
                const target = resolveLoginReturn(this.$route.query.returnPage, window.location.origin,
                    process.env.VUE_APP_LOGIN_RETURN_TARGETS, process.env.VUE_APP_LOGIN_RETURN_ORIGINS)
                if (!target) {
                    this.$router.push('dashboard')
                    return
                }
                const destination = this.$route.query.auth == 2
                    ? appendLoginDisplayFields(target, { userId: this.userId, userNick: this.userNick })
                    : target.href
                window.location.replace(destination)
            },
            closeEditDialog(){
                this.returnPageFun()
            },
            DingLogin(code,from){
                let param = from=='ding'
                    ? {code,corpId:this.corpId,autoLogin:this.form.autoLogin ? 1 : 0}
                    : {code,autoLogin:this.form.autoLogin ? 1 : 0}
                // 2026-08-08 coder(lq): 参数为空时不发送，确保原管理平台钉钉登录请求与行为保持不变。
                if (this.codexPlusState) {
                    param.codexPlusState = this.codexPlusState
                    param.oauthState = this.$route.query.state || ''
                }
                this.$apiGet('lechun-baseservice/auth/loginDingDing',{...param}).then(res=>{
                    this.$message({
                        showClose: true,
                        message: '登录成功',
                        type: 'success'
                    });
                    window.localStorage.setItem('userId',res.userId);
                    if (this.codexPlusState) {
                        // 2026-08-08 coder(lq): 桌面端会自行轮询并关闭登录窗口，浏览器仅展示完成提示，避免跳进管理后台造成困惑。
                        this.codexPlusCompleted = true
                    } else {
                        this.returnPageFun()
                    }
                }).catch(error=>{
                    if (this.codexPlusState) {
                        // 2026-08-08 coder(lq): CodexPlus OAuth 页面必须自行结束加载态并展示可操作错误，不能只依赖全局消息后一直停在“登录中”。
                        this.codexPlusError = (error && (error.message || error.msg)) || '钉钉登录失败，请返回 CodexPlus 重新发起'
                    }
                })
            },
            dingLoginPage(){
                if (this.codexPlusState && !this.isValidCodexPlusState(this.codexPlusState)) {
                    // 2026-08-08 coder(lq): 桌面登录 state 仅接受服务端生成格式，非法参数不继续带入钉钉 OAuth 地址。
                    this.codexPlusError = '登录状态无效，请返回 CodexPlus 重新发起'
                    return
                }
                let returnPage = this.returnPage||encodeURIComponent('https://portal.lechun.cc')
                let callbackParams = `returnPage=${returnPage}&autoLogin=${this.form.autoLogin ? 1 : 0}`
                if (this.codexPlusState) {
                    callbackParams += `&codexPlusState=${encodeURIComponent(this.codexPlusState)}`
                }
                let redirectUri = encodeURIComponent(`${window.location.origin}/login?${callbackParams}`)
                let oauthState = this.codexPlusState || 'lechun'
                window.location.href = 'https://login.dingtalk.com/oauth2/auth?' +
                    'redirect_uri='+ redirectUri +
                    '&response_type=code' +
                    '&client_id=' + this.clientId+
                    '&scope=openid' +
                    '&state=' + encodeURIComponent(oauthState) +
                    '&prompt=consent'
            }
        }
    }
</script>


<style lang="scss" rel="stylesheet/scss">
    .login-wrap{
        width: 100%;
        height: 100%;
        background: url("../assets/images/blur-bg.jpg");
        background-size: cover;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        .login-container{
            width: 480px;
            background-color: rgba(0,0,0,.5);
            border: none;
            border-radius: 5px;
            position: relative;
            margin-bottom: 24px;
            box-shadow: 0 5px 5px 0 rgba(0,0,0,.25);
            .el-form-item__label{
                color: #ffffff;
            }
            &-header{
                border-bottom: 1px solid rgba(0,0,0,.12);
                line-height: 55px;
                box-shadow: 0 1px 0 0 rgba(255,255,255,.12);
                box-sizing: border-box;
                h3{
                    margin: 0;
                    font-size: 20px;
                    text-align: center;
                }
            }
            &-body{
                padding: 15px 22px;
                box-sizing: border-box;
                .forget-password{
                    display: flex;
                    justify-content: flex-end;
                    font-size: 12px;
                    margin: -10px 0 20px;
                    span{
                        cursor: pointer;
                    }
                }
                .img-input{
                    .el-input-group__append{
                        background: #ffffff;
                    }
                }
                .auto-login-item{
                    margin-bottom: 18px;
                    .el-form-item__content{
                        line-height: 1;
                    }
                }
                .auto-login-row{
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    min-height: 24px;
                }
                .auto-login-check{
                    display: inline-flex;
                    align-items: center;
                    padding: 2px 0 2px 6px;
                    .el-checkbox__label{
                        display: inline-block;
                        padding-left: 10px;
                        color: #ffffff !important;
                        font-size: 14px;
                        font-weight: 600;
                        letter-spacing: .5px;
                        text-shadow: 0 1px 2px rgba(0,0,0,.45);
                    }
                    .el-checkbox__inner{
                        width: 16px;
                        height: 16px;
                        border-color: rgba(255,255,255,.85);
                        background: rgba(255,255,255,.18);
                    }
                    &.is-checked{
                        .el-checkbox__inner{
                            border-color: #2fc7b4;
                            background: #2fc7b4;
                        }
                    }
                }
            }
            .codexplus-login-result{
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 8px;
                padding: 28px 20px 32px;
                color: #ffffff;
                .el-icon-circle-check{
                    color: #67c23a;
                    font-size: 36px;
                }
                &.codexplus-login-error .el-icon-warning-outline{
                    color: #f56c6c;
                    font-size: 36px;
                }
                strong{
                    font-size: 16px;
                }
                span{
                    color: rgba(255,255,255,.72);
                    font-size: 13px;
                }
            }
        }
        .el-tabs--border-card{
            background: transparent;
            border:none;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.32), 0 0 6px 0 rgba(0, 0, 0, 0.24);
        }

        .el-tabs--border-card > .el-tabs__header{
            background: transparent;
            border-bottom: 1px solid rgba(0, 0, 0, 0.12);
            box-shadow: 0 1px 0 0 rgba(255, 255, 255, 0.12);
        }
        .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active{
            color: #ffffff;
            background-color: #209e91;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            border:none;
        }

    }

</style>
